
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const track = (event, params = {}) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
};


export const PageViewTracker = () => {
  const location = useLocation();
  const { i18n } = useTranslation();
  useEffect(() => {
    track('spa_page_view', {
      page_path: location.pathname + location.search,
      language: (i18n.language || 'en').toLowerCase(),
    });
  }, [location, i18n.language]);
  return null;
};
